import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=00fe6fd8&scoped=true"
import script from "./Treatment.vue?vue&type=script&lang=js"
export * from "./Treatment.vue?vue&type=script&lang=js"
import style0 from "./Treatment.vue?vue&type=style&index=0&id=00fe6fd8&lang=css"
import style1 from "./Treatment.vue?vue&type=style&index=1&id=00fe6fd8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fe6fd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00fe6fd8')) {
      api.createRecord('00fe6fd8', component.options)
    } else {
      api.reload('00fe6fd8', component.options)
    }
    module.hot.accept("./Treatment.vue?vue&type=template&id=00fe6fd8&scoped=true", function () {
      api.rerender('00fe6fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/treatment/Treatment.vue"
export default component.exports